import { render } from "./HeadImgDialog.vue?vue&type=template&id=5116d5b2&scoped=true"
import script from "./HeadImgDialog.vue?vue&type=script&lang=js"
export * from "./HeadImgDialog.vue?vue&type=script&lang=js"

import "./HeadImgDialog.vue?vue&type=style&index=0&id=5116d5b2&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5116d5b2"]])

export default __exports__